export { default } from "bullitttime-embercomponents/components/error-banner";
